<template>
  <rand-money :title="title" :cur-class="curClass" />
</template>

<script>
import RandMoney from '@/views/config/rand-conf/rand-money.vue'

export default {
  name: 'RandDiamond',
  components: { RandMoney },
  data() {
    return {
      title: '随机钻石配置',
      curClass: 'randDiamond'
    }
  }
}
</script>

